import { render, staticRenderFns } from "./data-table-resize-col.vue?vue&type=template&id=06041c0e&scoped=true"
import script from "./data-table-resize-col.vue?vue&type=script&lang=ts"
export * from "./data-table-resize-col.vue?vue&type=script&lang=ts"
import style0 from "./data-table-resize-col.vue?vue&type=style&index=0&id=06041c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06041c0e",
  null
  
)

export default component.exports